import { DashboardShell } from "../components/dashboard-shell/dashboard-shell";
import { McpSetupView } from "../features/mcp-setup/mcp-setup-view";

export function McpSetupPage(): JSX.Element {
  return (
    <DashboardShell>
      <McpSetupView />
    </DashboardShell>
  );
}
